import { createSlice } from "@reduxjs/toolkit";
import { getSurveyList } from "../reduxApi/surveyReduxApi";

const surveySlice = createSlice({
    name: 'survey',
    initialState: {
        status: 'idel',
        survey: [],
    },
    reducers: {
        deleteSurveyAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.survey.findIndex((item) => item.rowId === id);
                if (index !== -1) {
                    state.survey.splice(index, 1);
                }
            });
        },
        updateSurveyAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.survey.findIndex((item) => item.rowId === action.payload.rowId)
            if (index != -1) {
                state.survey.splice(index, 1,  action.payload )
            }
        },
        addSurveyAction: (state, action) => {
            console.log("Adding Survey:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.rowId
            state.survey.unshift(temp); 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSurveyList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getSurveyList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing Survey Data", action.payload)
                state.survey = action.payload.data.response
;
            })
    }
})
export const { deleteSurveyAction, updateSurveyAction, addSurveyAction } = surveySlice.actions
export default surveySlice.reducer